// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"CardWithButton-module--buttonWrapper--2ORfA","image":"CardWithButton-module--image--3oz3e","buttonTitle":"CardWithButton-module--buttonTitle--1Djhp"};